import React from "react";
import Select from "react-select";
import { Field, ErrorMessage } from "formik";
import { FormControl, FormHelperText } from "@mui/material";

const ReactCustomSelect = ({ options, name, props, onChange, disabled }) => {
  const value = props.values[name];

  return (
    <FormControl fullWidth variant="outlined" size="small">
      <Field
        as={Select}
        name={name}
        options={options}
        value={options.find((option) => option.value === value) || null}
        onChange={(selectedOption) => {
          props.setFieldValue(name, selectedOption?.value || null);
          if (onChange) {
            onChange(selectedOption);
          }
        }}
        isSearchable={true}
        placeholder="Select an option"
        isClearable
        isDisabled={disabled}
      />

      <FormHelperText sx={{ color: "red" }}>
        <ErrorMessage name={name} />
      </FormHelperText>
    </FormControl>
  );
};

export default ReactCustomSelect;
